<template>
<v-row>
    <v-overlay
      :opacity="0.5"
      :value="loading"
    >
      <v-progress-circular indeterminate size="256">
        Por favor, aguarde ...
      </v-progress-circular>
    </v-overlay>    
    <v-col cols="12" sm="12" md="12">
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <botaoVoltar />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <h2>Nova Solicitação <span v-if="this.isTrueValue(this.isDelegatedUser)">por Delegação</span></h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <v-form
                    v-model="valid"
                    ref="formSaveRequest"
                >
                    <v-row v-if="this.isTrueValue(this.delegatedUser)">
                        <v-col cols="12" sm="6" md="6">
                            <v-select
                                outlined
                                :items="listOrigemProcura"
                                item-value="Id"
                                item-text="Descricao"
                                label="Origem Procura *"
                                @change="changeOrigemProcura($event)"
                                v-model="codigoOrigemProcura"
                                :rules=[rules.origemProcuraRequired]
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="this.showResquestAgency">
                            <v-select
                                outlined
                                :items="listOrgaos"
                                label="Órgão Solicitante *"
                                v-model="codigoOrgaoSolicitante"
                                :rules=[rules.orgaoSolicitanteRequired]
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="4">
                            <v-select
                            outlined
                            :items="listPerfilSolicitacao"
                            v-model="tipoPerfilSolicitacao"
                            label="Perfil da solicitação *"
                            id="cboTipoPerfilSolicitacao"
                            :rules="[rules.required]"
                            @change="changeTipoPerfil"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="tipoPerfilSolicitacao == 'G'">
                            <v-select
                            outlined
                            :items="listaSimNao"
                            v-model="acolhimentoSeparado"
                            item-text="text"
                            item-value="value"
                            label="Aceita acolhimento separado? *"
                            :rules="[rules.required]"
                            :required="isPerfilGrupo"
                            ></v-select>
                        </v-col>  
                    </v-row>
                    <v-row>                      
                        <v-col cols="12" sm="12" md="6">
                            <v-select
                                outlined
                                :items="listTipoSolicitacao"
                                v-model="tipoSolicitacao"
                                item-text="text"
                                item-value="value"
                                label="Tipo de solicitação *"
                                :rules="[rules.required]"
                                @change="listServiceByRequestType($event)"
                                :disabled="VerificaTipoSolicitacao"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-select
                                clearable
                                outlined
                                :items="listTipologiaPorTipoSolicitacao"
                                v-model="tipoServicoReordenamentoAcolhimento"
                                item-text="Descricao"
                                item-value="ID"
                                :label="labelTipoServico"
                                :rules="[rules.required]"
                                id="cbotipoServicoReordenamentoAcolhimento"
                            ></v-select>
                        </v-col>
                        
                    </v-row>   
                    <v-row> 
                        <v-col cols="12" sm="12" md="7">
                            <v-text-field
                            outlined
                            clearable
                            :disabled="!this.isTrueValue(this.delegatedUser)"
                            v-model="nomeResponsavelSolicitacao"
                            :rules="[rules.required]"
                            id="txtNomeResponsavelSolicitacao"
                            label="Nome solicitante *"></v-text-field>
                        </v-col>
                        <v-col cols="12"  md="5">
                            <v-text-field-simplemask
                                label="Telefone para comunicação *"
                                v-model="telefoneResponsavelSolicitacao"
                                v-bind:properties="{
                                    prefix: '',
                                    suffix: '',
                                    readonly: false,
                                    disabled: false,
                                    outlined: true,
                                    clearable: true,
                                    placeholder: '',
                                    required: true,
                                }"
                                v-bind:options="{
                                    humanMask: '(##) #####-####',
                                    machineMask: '###########',
                                    empty: null,
                                    applyAfter: false,
                                    alphanumeric: false,
                                    lowerCase: false,
                                    rules: [rules.required, rules.telefone],
                                }"
                            />                            
                        </v-col>

                    </v-row>
                    <v-row> 
                        <!-- <v-col cols="12" sm="12" md="5">
                                &nbsp;
                        </v-col> -->
                        <v-col cols="12" sm="12" md="6" >
                            <v-text-field 
                            outlined
                            clearable
                            v-model="emailResponsavelSolicitacao"
                            :rules="[rules.required, rules.email]"
                            label="E-mail para comunicação 1 *"
                            title="E-mail obrigatório para o recebimento da resposta do atendimento">
                             
                        </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                            <v-text-field 
                            outlined
                            clearable
                            v-model="emailResponsavelSolicitacaoSecundario"
                            :rules="[rules.email]"
                            label="E-mail para comunicação 2"
                            title="E-mail opcional para o recebimento da resposta do atendimento">
                            </v-text-field>
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h3>Endereço de Referência do(s) Cidadão(s)</h3>
                        </v-col>
                    </v-row>                    
                    <v-row>
                        <v-col cols="9" sm="10" md="2">
                            <v-text-field-cep
                                v-model="enderecoSolicitacao.cep"
                                label="CEP"
                                @change="cepChange(enderecoSolicitacao.cep)"
                                v-bind:properties="{
                                    disabled: false,
                                    outlined: true,
                                    clearable: true,
                                    placeholder: '',
                                }"
                                v-bind:options="{
                                    machineMask: '########',
                                    empty: null,
                                    applyAfter: true,
                                }"
                            />
                        </v-col>
                        <v-col cols="3" sm="2" md="1">
                            <v-btn
                                color="primary"
                                large
                                class="ma-1"
                                rounded
                                elevation="0"
                                @click="searchStreeByCEP()"
                                >
                                <v-icon dark>
                                    mdi-home-search
                                </v-icon>
                            </v-btn>                        
                        </v-col>    
                        <v-col cols="12" sm="10" md="5">                        
                            <v-text-field
                                outlined
                                clearable
                                v-model="enderecoSolicitacao.nomeLogradouro"
                                label="Logradouro"
                                :disabled="false"
                                maxLength="50"
                            />
                        </v-col>
                        <v-col cols="4" sm="2" md="2">                        
                            <v-text-field
                                outlined
                                clearable
                                v-model="enderecoSolicitacao.numeroLogradouro"
                                label="Número"
                                :disabled="false"
                                maxLength="10"
                                required
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">                        
                            <v-text-field 
                                outlined
                                clearable
                                v-model="enderecoSolicitacao.complemento"
                                label="Complemento"
                                :disabled="false"
                                maxLength="15"
                            />
                        </v-col>                       
                        <v-col cols="12" sm="6" md="6">                        
                            <v-select
                                outlined
                                clearable
                                required
                                item-value="SubprefeituraId"
                                item-text="DescricaoSubprefeitura"
                                :items="listSubPrefeituras"
                                v-model="enderecoSolicitacao.codigoSubprefeitura"
                                label="Subprefeitura *"
                                @change="changeBorough($event)"
                                :rules="[rules.required]"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">                        
                            <v-select
                                outlined
                                clearable
                                item-value="DistritoId"
                                item-text="DescricaoDistrito"
                                :items="listDistrict"
                                v-model="enderecoSolicitacao.codigoDistrito"
                                label="Distrito *"
                                :rules="[rules.required]"
                            />                                
                        </v-col>                           
                        
                    </v-row>  
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h2>Relato da solicitação</h2>
                        </v-col>
                    </v-row>                    
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                                <v-textarea
                                    outlined
                                    no-resize
                                    clearable
                                    label="Breve relato da solicitação *"
                                    v-model="breveRelato"
                                    maxLength="500"
                                    rows="5"
                                    rows-height="5"
                                    background-color="#FAFAFA"
                                    :counter="500"
                                    :rules="[rules.required]"
                                />
                        </v-col>
                    </v-row>                   
                    <v-row>
                        <v-col cols="12" sm="12" md="6">
                            <v-select
                                clearable 
                                outlined
                                id="motivoProcura"
                                label="Motivo da Solicitação"
                                :items="listMotivos"
                                v-model="motivoProcura"
                                :rules="[rules.motivoAcholhimentoRequired]"
                                v-show="tipoSolicitacao == 'A'"
                            ></v-select>
                            <v-select
                                clearable 
                                outlined
                                id="motivoReordenamento"
                                label="Motivo do Reordenamento"
                                :items="listMotivosReordenamento"
                                v-model="motivoReordenamento"
                                :rules="[rules.motivoReordenamentoRequired]"
                                v-show="tipoSolicitacao == 'R'"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12" class="text-left">
                            <v-btn 
                                elevation="0"
                                rounded
                                color="primary"
                                x-large
                                @click="this.addCitizen"
                            ><v-icon left>mdi-account-multiple-plus</v-icon>
                            Adicionar Cidadão</v-btn>
                            <modalAddCitizen ref="mdAddCitizen" :dialog.sync="showModalCitizen" />
                        </v-col>
                    </v-row>
                    
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <v-data-table v-if="listCitizen.length > 0"
                    :headers="headers"
                    :items="listCitizen"
                    :footer-props="$config.pagingProps"
                    :items-per-page="$config.maxItensPerPage"
                    :loading="loading"
                    class="elevation-0"
                >
                    <template v-slot:[`item.dataNascimento`]="{ item }">
                        <span>{{ item.dataNascimento | formatDate_BR() }}</span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon 
                        dense
                        class="mr-2"
                        @click="removeCitizen(item.idGrid, item.nome)"
                        title="Excluir"
                        >
                        mdi-delete
                        </v-icon>
                        <v-icon 
                        dense
                        class="mr-2"
                        @click="updateCitizen(item.idGrid)"
                        title="Alterar"
                        >
                        mdi-account-edit
                        </v-icon>
                    </template>
                </v-data-table>
                <v-chip v-else
                    color="#CFD8DC" 
                    >
                    Nenhum cidadão cadastrado
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
                <v-col cols="12" sm="12" md="12">
                    <h2>Arquivos da Solicitação</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <span>
                        Não envie documentos pessoais e/ou fotos do cidadão. Para saber quais documentos enviar, consulte as fichas técnicas de cada tipologia disponíveis no site <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/assistencia_social/central_de_vagas/' target="blank">Central de Vagas</a>
                    </span>
                </v-col>                
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <SelectFiles ref="selectFiles" :requestID="0" :status="1" />
                </v-col>
            </v-row>  
        <v-row>
            <v-col cols="12" sm="12" md="8" lg="2">
                <v-btn 
                    rounded
                    block
                    color="primary"
                    x-large
                    elevation="0"
                    @click="saveRequest"
                    v-show="!loading"
                ><v-icon small left>mdi-content-save</v-icon>Salvar</v-btn>
<!-- 
                 <v-btn
                    color="success"
                    text
                    @click="incluirArquivo"
                >
                    <v-icon left>mdi-file-image-add-outline</v-icon>Incluir Arquivos
                </v-btn> -->
            </v-col>
        </v-row>
    </v-col>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />        
        <v-dialog
            v-model="dialogRequestInserted"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Solicitação de Vagas criada
                </v-card-title>

                <v-card-text>
                <br/>
                Foi criada a solicitação de vaga com o protocolo: <span class="font-weight-bold">{{ getSavedIdRequest }}</span>
                <br/>
                Foi enviada uma mensagem com dados resumidos da solicitação ao endereço de e-mail informado para o responsável da solicitação.
                <br/>
                Caso a mensagem não tenha chegado, os dados e situação da solicitação podem ser consultados a partir do protocolo: <span class="font-weight-bold">{{ getSavedIdRequest }}</span>                
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>                
                <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    rounded
                    @click="$router.push({ name: 'ListRequest' })"
                >
                   <v-icon left>mdi-check</v-icon> CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>
       <v-dialog
            v-model="dialogError"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Atenção
                </v-card-title>

                <v-card-text>
                <br/>
                <p>{{returnedTitleMessage}}</p>
                <div class="text--primary espaco-top" v-html="returnedErrorMessage"></div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    rounded
                    @click="dialogError = false"
                >
                    CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>        
</v-row>
</template>
<script>
import snackbarMixin from "@/mixins/snackbar.mixin";
import { mapGetters, mapMutations } from 'vuex';
import GoBack from '@/components/GoBack.vue';
import AddCitizen from '../citizen/AddCitizenFull.vue';
import loginService from '../../services/security/login.service';
import Cep from '../../components/masked/Cep.vue';
import SelectFiles from '@/components/SelectFiles.vue';
import SimpleMask from "../../components/masked/simple-mask.vue";
import moment from 'moment';

export default {
    mixins: [snackbarMixin],
    components:{
        'botaoVoltar': GoBack,
        'modalAddCitizen': AddCitizen,
        "v-text-field-cep": Cep,
        'v-text-field-simplemask': SimpleMask,  
        SelectFiles              
    },
    data(){
        return {
            loading: false,
            dialogRequestInserted: false,
            dialogError: false,
            returnedErrorMessage: '',
            returnedTitleMessage:'Não foi possível efetuar a inclusão da solicitação.',
            valid:true,
            nomeResponsavelSolicitacao:'',
            telefoneResponsavelSolicitacao:'',
            emailResponsavelSolicitacao:'',
            emailResponsavelSolicitacaoSecundario:'',
            tipoSolicitacao: 'A',
            tipoPerfilSolicitacao:'I',
            indicadorSituacaoRua: "false",
            breveRelato:'',
            tipoServicoReordenamentoAcolhimento: '',
            codigoOrigemProcura: '',
            codigoOrgaoSolicitante: '',
            indicadorAbertaDelegacao: false,
            listaSimNao: [{text: 'Sim', value:'1'},{text: 'Não', value:'0'}],
            acolhimentoSeparado:'0',
            isPerfilGrupo:false,
            enderecoSolicitacao: {
                codigoTipoLogradouro: '',
                codigoSubprefeitura: '',
                codigoDistrito: '',
                pontoReferencia: '',
                nomeLogradouro: '',
                numeroLogradouro: '',
                complemento: '',
                nomeBairro: '',
                cep: '',
                codigoCidade: '',
                siglaUF: ''
            },
            headers:[
                { text: "Item", value: "idGrid" },
                { text: "Nome", value: "nome" },
                { text: "Nome social", value: "nomeSocial" },
                { text: "Nome da Mãe", value: "nomeMae" },
                { text: "Data de Nascimento", value: "dataNascimento" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            isDelegatedUser: false,
            showResquestAgency: false,
            isEnabledConvalescence: false,
            labelComboMotivo: '',
            listCitizen:[],
            listMotivos: [],
            listMotivosReordenamento: [],
            motivoProcura:'',
            motivoReordenamento: '',
            listOrgaos:[],
            orgao:'',
            showOrgaoSolicitante:true,
            showModalCitizen:false,
            showModalUpload:false,   
            uploadSuccess: false,         
            labelTipoServico: 'Tipo de serviço para acolhimento *',
            listPerfilSolicitacao: [{text:'Individual', value:'I'},{text:'Casal', value:'C'},{text:'Grupo Familiar', value:'G'}],
            listTipoSolicitacao: [{ text: 'Acolhimento', value: 'A'}, { text: 'Reordenamento', value: 'R' }],
            listCityAddress: [],
            listDistrict: [],
            listTipologiaPorTipoSolicitacao: [],
            rules:{
                    required: value => !!value || 'Campo obrigatório',
                    email: value => {
                        if(value == null || value == undefined || value == "" )
                        {
                            return true;
                        }
                        else{
                        const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        return pattern.test(value) || 'e-mail inválido.'
                        }
                        
                    },
                    telefone: value => {
                        if(value == null || value == undefined || value == "" )
                        {
                            return true;
                        }
                        else if (!ValidarNumeroDefault(value)) {
                            return  false || 'telefone inválido.';
                            }
                        else{
                        
                        return (value.length > 13 ) || 'telefone inválido.'
                        }
                    },
                    orgaoSolicitanteRequired: value => ( this.checkOrgaoSolicitanteRequired(value) || "Campo obrigatório"),
                    origemProcuraRequired: value => ( this.checkOrigemProcuraRequired(value) || "Campo obrigatório"),
                    motivoAcholhimentoRequired: value => this.validaMotivoAcolhimentoObrigatorio(value) || "Campo obrigatório",
                    motivoReordenamentoRequired: value => this.validaMotivoReordenamentoObrigatorio(value) || "Campo obrigatório"

            }
        }
    },
    watch: {
        showModalCitizen(value) {
            if(value){
                console.log()
            }
        }           
    },
    computed:{
       ...mapGetters('login',['nameInstitution', 'userName','userEmail','delegatedUser']),
       ...mapGetters('lists',['listSubPrefeituras','listPais','listTipoLogradouro','listTipologiaServicoReordenamento','listTipologiaServicoAcolhimento','listOrigemProcura','listMotivoReordenamento']),        
       ...mapGetters('request',['getSavedIdRequest','getReturnStatus','getErrosOnSave']),
       ...mapGetters('common',['getSourceSearch','getRequestingAgency','getEnabledReordering','getEnabledConvalescence','getEnabledOnlyReordering']),

       VerificaTipoSolicitacao(){
        console.log('this.getEnabledReordering',this.isTrueValue(this.getEnabledReordering));
        console.log('this.getEnabledOnlyReordering',this.isTrueValue(this.getEnabledOnlyReordering));
        console.log('this.retornoValidacao',!this.isTrueValue(this.getEnabledReordering) && !this.isTrueValue(this.getEnabledOnlyReordering));

        if(this.isTrueValue(this.getEnabledReordering) == true && this.isTrueValue(this.getEnabledOnlyReordering) == true)
        {
            console.log('condicao 1 false');
            //this.tipoSolicitacao = 'R';
            return false;
            
        }
        else if(this.isTrueValue(this.getEnabledReordering) == false && this.isTrueValue(this.getEnabledOnlyReordering) == false)
            {

                console.log('condicao 2 false');
                //this.tipoSolicitacao = 'A';
                return true;
                
            }
        else
            {
                console.log('condicao 3 true');
                return false;
                
            }

            //return ();
        },
    },
    mounted() {
        this.isDelegatedUser = this.$store.state.login.delegatedUser;
        this.loadMotivoProcura();
        this.loadMotivoReordenamento();
        if(!this.isTrueValue(this.isDelegatedUser)){
            this.nomeResponsavelSolicitacao = this.userName;
            this.emailResponsavelSolicitacao = this.userEmail;
            this.isEnabledConvalescence = this.getEnabledConvalescence;
            this.updateEnabledConvalescence(this.isEnabledConvalescence);
        } else {
            this.loadOrigemProcura();
        }
        this.loadBorough();
        this.loadStreetType();
        this.loadServiceType(0);

        console.log('this.getEnabledReordering',this.getEnabledReordering);
        console.log('this.getEnabledOnlyReordering',this.getEnabledOnlyReordering);
/*        
        if(this.isTrueValue(this.getEnabledOnlyReordering)){
            this.tipoSolicitacao = 'R';
        }
        else if(!this.isTrueValue(this.getEnabledReordering) && !this.isTrueValue(this.getEnabledOnlyReordering)){
            this.tipoSolicitacao = 'A';
        }
        else
        {
            this.tipoSolicitacao = 'A';
        }
*/
        this.tipoSolicitacao = 'A';

        console.log("this.tipoSolicitacao", this.tipoSolicitacao);

        this.listServiceByRequestType(this.tipoSolicitacao);
        this.updatePreviousPage('request');

        console.log("this.tipoSolicitacao - 2", this.tipoSolicitacao);
    },
    beforeCreate(){
    },
    methods:{
        ...mapMutations('common', ['updatePreviousPage','updateEnabledConvalescence','updateEnabledReordering','updateEnabledOnlyReordering']),


        async loadOrigemProcura(){
            await this.$store.dispatch("lists/listOrigemProcura");
        },
        async changeOrigemProcura(item){
            this.listOrgaos = [];
            this.showResquestAgency = false;
            if(item!=null) {
                var objOrigem = this.listOrigemProcura.find(op => op.Id == item);
                console.log('objOrigem', objOrigem);
                this.codigoOrgaoSolicitante = '';
                if(objOrigem != null){
                    this.isEnabledConvalescence = objOrigem.OrgaoSolicitaConvalescencia
                    this.updateEnabledConvalescence(this.isEnabledConvalescence);
                    this.updateEnabledReordering(this.isTrueValue(objOrigem.OrgaoSolicitaReordenamento));

                    if(objOrigem.OrgaoSolicitaReordenamento == 0 || objOrigem.OrgaoSolicitaReordenamento == 1)
                    {
                        this.tipoSolicitacao = 'A';
                        this.listServiceByRequestType(this.tipoSolicitacao);                        
                    }
                    else if (objOrigem.OrgaoSolicitaReordenamento == 2)
                    {
                        this.tipoSolicitacao = 'R';
                        this.listServiceByRequestType(this.tipoSolicitacao);                        
                    }
                    //if(!this.isTrueValue(objOrigem.OrgaoSolicitaReordenamento)){
                        //this.tipoSolicitacao = 'A';
                        //this.listServiceByRequestType(this.tipoSolicitacao);
                    //}
                }
                
                await this.$store.dispatch("lists/listOrgaoSolicitante", item.toString());
                try {
                    let orgaos = this.$store.state.lists.list;
                    if(orgaos != null){
                        this.listOrgaos = [];
                        this.showOrgaoSolicitante=false;

                        for (let index = 0; index < orgaos.length; index++) {
                            this.listOrgaos.push({
                                text: orgaos[index].dcServico,
                                value: orgaos[index].cdServico,
                            });
                        }
                        this.showResquestAgency = (this.listOrgaos != null && this.listOrgaos.length > 0);
                    }else{
                        this.showOrgaoSolicitante=true;
                    }
                    this.listServiceByRequestType(this.tipoSolicitacao);
                } catch (error) {
                    this.showSnackbar(error, 'error');
                }
            }
        },
        async loadMotivoProcura() {
        await this.$store.dispatch("lists/listMotivoProcura");
        try {
            let motivos = this.$store.state.lists.listMotivoProcura;
            this.listMotivos = [];
            for (let index = 0; index < motivos.length; index++) {
                this.listMotivos.push({
                    text: motivos[index].Descricao,
                    value: motivos[index].Id,
                });
            }
        } catch (error) {
            this.showSnackbar(error, 'error');
        }
        },
        async loadMotivoReordenamento() {
        await this.$store.dispatch("lists/listMotivoReordenamento");
        try {
            let motivos = this.$store.state.lists.listMotivoReordenamento;
            this.listMotivosReordenamento = [];
            for (let index = 0; index < motivos.length; index++) {
                this.listMotivosReordenamento.push({
                    text: motivos[index].Descricao,
                    value: motivos[index].Id,
                });
            }
        } catch (error) {
            this.showSnackbar(error, 'error');
        }
        },        
        changeTipoPerfil(){
            return this.isPerfilGrupo = this.tipoPerfilSolicitacao == 'G' ? true : false;
        },
        
        addCitizen(){
            this.checkUserLogged();
            if(!this.isTrueValue(this.delegatedUser) && (this.getSourceSearch == null || this.getSourceSearch == undefined || this.getSourceSearch.length == 0)){
                this.dialogError = true;
                this.returnedErrorMessage = 'Selecione o órgão para o qual está sendo efetuada a solicitação.';
                return false;
            }

            if(this.tipoPerfilSolicitacao == "I" || this.tipoPerfilSolicitacao == "G" || this.tipoPerfilSolicitacao == "C"){
                if(this.tipoPerfilSolicitacao == "I" && this.listCitizen.length == 1){
                    this.dialogError = true;
                    this.returnedErrorMessage = 'Para solicitação de perfil individual somente é permitida a indicação de um cidadão.';
                    this.$refs.formSaveRequest.$el.cboTipoPerfilSolicitacao.focus();
                    return false;
                }
                if(this.tipoPerfilSolicitacao == "C" && this.listCitizen.length == 2){
                    this.dialogError = true;
                    this.returnedErrorMessage = 'Para solicitação de perfil casal somente é permitida a indicação de dois cidadãos.';
                    this.$refs.formSaveRequest.$el.cboTipoPerfilSolicitacao.focus();
                    return false;
                }
                this.$refs.mdAddCitizen.setCitizenUpdate('');
                this.$refs.mdAddCitizen.initDisabledForm(false);
                this.showModalCitizen=true;
            } else {
                this.dialogError = true;
                this.returnedErrorMessage = 'Informe o tipo de perfil da solicitação.';
            }
        },
        profileNotSelected(value){
            var msg = "Selecione um perfil de solicitação.";
            if(value instanceof Array && value.length === 0){
                return msg;
            }
            return !!value || msg;
        },
        requestTypeNotSelected(value){
            var msg = "Selecione o tipo de solicitação.";
            if(value instanceof Array && value.length === 0){
                return msg;
            }
            return !!value || msg;
        },
        searchReasonNotSelected(value){
            var msg = "Selecione o motivo de procura.";
            if(value instanceof Array && value.length === 0){
                return msg;
            }
            return !!value || msg;
        },
        sourceNotSelected(value){
            var msg = "Selecione Origem da procura.";
            if(value instanceof Array && value.length === 0){
                return msg;
            }
            return !!value || msg;
        },
        removeCitizen(index, nome){
            let msg = 'Deseja realmente excluir o cidadão ' + nome + '?';
            this.$root.$confirm.open('Delete', msg)
            .then((res)=> {
                if(res==true){
                    let tagFind = this.listCitizen.map(e=>e.idGrid).indexOf(index);
                    //remove o item do array
                    this.listCitizen.splice(tagFind,1);
                    this.listCitizen =  this.listCitizen.sort((a,b) => ( parseInt(a.idGrid) < parseInt(b.idGrid)) ? 1 : ((parseInt(b.idGrid) > parseInt(a.idGrid) ? -1 : 0)));
                    for (let index = 0; index < this.listCitizen.length; index++) {
                        this.listCitizen[index].idGrid = (index + 1);
                    }
                }

            });

        },
        updateCitizen(index){
            let tagFind = this.listCitizen.map(e=>e.idGrid).indexOf(index);
            //remove o item do array
            this.showModalCitizen=true;
            this.$refs.mdAddCitizen.initDisabledForm();
            this.$refs.mdAddCitizen.setCitizenUpdate(this.listCitizen[tagFind]);
        },
        validateProfileByCitizen(){
            if(!this.isTrueValue(this.delegatedUser) && (this.getSourceSearch == null || this.getSourceSearch == undefined || this.getSourceSearch.length == 0))
            {
                this.dialogError = true;
                this.returnedErrorMessage = 'Selecione o órgão para o qual está sendo efetuada a solicitação';
                return false;
            }

            /*VALIDA CASAL TIPO SERVICO**/
            if(this.tipoPerfilSolicitacao == "C"){

               var TipoServFind = this.listTipologiaPorTipoSolicitacao;
               TipoServFind = TipoServFind.find(x => x.ID == this.tipoServicoReordenamentoAcolhimento);
               console.log('TipoServFind', TipoServFind.Descricao);
               if(TipoServFind.Descricao != "AUTONOMIA EM FOCO" 
                  && TipoServFind.Descricao != "CAE FAMILIAS")
                {
                //var valorTeste =  this.cbotipoServicoReordenamentoAcolhimento. ;
                this.dialogError = true;
                this.returnedErrorMessage = 'O Tipo de Serviço selecionado não é permitido para o Perfil de Solicitação Casal.';
                return false;
                }
            }
            /*VALIDA CASAL TIPO SERVICO*/

            if(this.listCitizen == null || this.listCitizen.length == 0){
                this.dialogError = true;
                this.returnedErrorMessage = 'Nenhum cidadão foi adicionado';
                return false;
            }
            if((this.tipoPerfilSolicitacao == "I" && this.listCitizen.length != 1)
                || (this.tipoPerfilSolicitacao == "G" && this.listCitizen.length < 2)
                || (this.tipoPerfilSolicitacao == "C" && this.listCitizen.length != 2)){
                this.dialogError = true;
                this.returnedErrorMessage = 'Quantidade de cidadão(s) não está de acordo com o perfil da solicitação.';
                return false;
            }

            if(this.listCitizen.length > 0  && this.tipoPerfilSolicitacao == "C"){
                var CidadaoIdade = null;
                    CidadaoIdade = this.listCitizen.find(x => this.getPresentAge(x.dataNascimento) < 18);
                if(CidadaoIdade != undefined)
                {
                    this.dialogError = true;
                    this.returnedErrorMessage = 'Para o Perfil de Solicitação Casal, não é permitido que o cidadão seja menor que 18 anos. Cidadão - ' + CidadaoIdade.nome;
                    return false;
                }
                else
                {
                    //if(this.CidadaoIdade == undefined)
                    CidadaoIdade = null;      
                }

            }

            if(this.tipoServicoReordenamentoAcolhimento == null || this.tipoServicoReordenamentoAcolhimento == undefined || this.tipoServicoReordenamentoAcolhimento == ""){
                this.dialogError = true;
                this.returnedErrorMessage = 'Não foi informado o tipo de serviço de acolhimento ou reordenamento';
                return false;
            }


            return true;
        },
        // validadeFileUpload(){
        //     let result = false;
        //     let msg = 'Nenhum arquivo anexado na solicitação, deseja proseguir?';
        //     this.$root.$confirm.open('Salvar Solicitação',msg)
        //     .then((res) => {
        //         if(res == true){
        //            result = true;
        //         }
        //         else {
        //            result = false;
        //         }

        //         console.log(result);
        //         return result;
        //     });
        // },
        sleep(ms){
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        close() {
            this.showModalUpload = false;
        },
        incluirArquivo() {
            this.showModalUpload = true;
            this.$refs.selectFiles.loadFiles();
        },
        saveRequest(){
            if(this.$refs.formSaveRequest.validate()){
                if(this.validateProfileByCitizen()) {
                        if(this.$refs.selectFiles.files.length == 0){
                            let msg = 'Nenhum arquivo anexado na solicitação, deseja continuar?';
                            this.$root.$confirm.open('Salvar Solicitação', msg)
                            .then((res)=> {
                                if(res == true) {
                                    this.confirmSaveRequest();
                                }
                            });
                        } else{
                            this.confirmSaveRequest();
                        }
                } else {
                    this.$refs.formSaveRequest.$el.txtNomeResponsavelSolicitacao.focus();
                }
            }
        },
        confirmSaveRequest(){
            this.loading = true;
                        var objLogin = this.$store.state.login;
                        let data = {
                            nomeResponsavelSolicitacao: this.nomeResponsavelSolicitacao,
                            telefoneResponsavelSolicitacao: this.telefoneResponsavelSolicitacao,
                            emailResponsavelSolicitacao: this.emailResponsavelSolicitacao,
                            emailResponsavelSolicitacaoSecundario: this.emailResponsavelSolicitacaoSecundario,
                            tipoSolicitacao: this.tipoSolicitacao,
                            tipoPerfilSolicitacao: this.tipoPerfilSolicitacao,
                            indicadorSituacaoRua: (this.indicadorSituacaoRua == "true") ? true : false,
                            codigoMotivoProcura: (this.tipoSolicitacao == 'A') ? this.motivoProcura : '',
                            codigoMotivoReordenamento: (this.tipoSolicitacao == 'R') ? this.motivoReordenamento : '',
                            breveRelato:this.breveRelato,
                            status: 1, //aberta
                            cidadaos: this.listCitizen,
                            codigoUsuarioInclusao: objLogin.userLogin,
                            codigoTipoServico: this.tipoServicoReordenamentoAcolhimento,
                            codigoOrigemProcura: this.getOrigemProcura(),
                            codigoOrgaoSolicitante: this.getOrgaoSolicitante(),
                            indicadorAbertaDelegacao: this.isDelegatedUser,
                            acolhimentoSeparado: (this.acolhimentoSeparado == '1') ? true : false,
                            enderecoSolicitacao: {
                                codigoTipoLogradouro: this.enderecoSolicitacao.codigoTipoLogradouro,
                                codigoSubprefeitura: this.enderecoSolicitacao.codigoSubprefeitura,
                                codigoDistrito: this.enderecoSolicitacao.codigoDistrito,
                                pontoReferencia: this.enderecoSolicitacao.pontoReferencia,
                                nomeLogradouro: this.enderecoSolicitacao.nomeLogradouro,
                                numeroLogradouro: this.enderecoSolicitacao.numeroLogradouro,
                                complemento: this.enderecoSolicitacao.complemento,
                                nomeBairro: this.enderecoSolicitacao.nomeBairro,
                                cep: this.enderecoSolicitacao.cep,
                                codigoCidade: this.enderecoSolicitacao.codigoCidade,
                                siglaUF: this.enderecoSolicitacao.siglaUF
                            },
                            arquivos: this.$refs.selectFiles.files
                        };
                        this.$store.dispatch('request/save', data)
                        .then(()=> {
                            this.loading = false;
                            console.log(this.getReturnStatus);
                            if(this.getReturnStatus == 'OK'){
                                this.dialogRequestInserted = true;
                                this.clearForm();
                            } else {
                                this.dialogError = true;
                                this.returnedErrorMessage = '<ul><li>' + this.getErrosOnSave.join('<li /><li>') + '</li></ul>';
                                console.log(this.getErrosOnSave);
                                console.log(this.returnedErrorMessage);
                            }
                        })
                        .catch(error=>{
                            console.log(error);
                            this.loading = false;
                            this.showSnackbar('Não foi possível processar a requisição. Dados inválidos', 'error');
                        });  
        },
        getOrigemProcura(){
            if(this.isTrueValue(this.isDelegatedUser)){
                return this.codigoOrigemProcura;
            } else {
                return this.getSourceSearch;
            }
        },
        getOrgaoSolicitante(){
            if(this.isTrueValue(this.isDelegatedUser)){
                return this.codigoOrgaoSolicitante;
            } else {
                return this.getRequestingAgency;
            }
        },
        clearForm(){
            this.loading = false;
            this.valid = true;
            this.tipoSolicitacao = 'A';
            this.tipoPerfilSolicitacao = 'I';
            this.indicadorSituacaoRua = "false";
            this.breveRelato = '';
            this.tipoServicoReordenamentoAcolhimento = '';
            this.codigoOrigemProcura = '';
            this.codigoOrgaoSolicitante = '';
            this.enderecoSolicitacao =  {
                codigoTipoLogradouro: '',
                codigoSubprefeitura: '',
                codigoDistrito: '',
                pontoReferencia: '',
                nomeLogradouro: '',
                numeroLogradouro: '',
                complemento: '',
                nomeBairro: '',
                cep: '',
                codigoCidade: '',
                siglaUF: ''
            };
            this.motivoProcura = '';
            this.motivoReordenamento = '';
            this.orgao = '';
            this.showOrgaoSolicitante = true;
            this.showModalCitizen = false;
            this.showModalUpload = false;
            this.listDistrict = [];
            this.$refs.formSaveRequest.$el.motivoProcura.focus();
            this.listCitizen = [];
            this.listTipologiaPorTipoSolicitacao = [];
            if(this.isTrueValue(this.isDelegatedUser)){
                this.emailResponsavelSolicitacao = '';
                this.nomeResponsavelSolicitacao = '';
                this.telefoneResponsavelSolicitacao = '';
            }
        },
        checkUserLogged(){
        var objLogin = this.$store.state.login;
        loginService.getOperator(objLogin.userLogin)
        .then(() => 
        { 
            return true; 
        }).catch(error => 
        { 
            if(error.toString().indexOf('code 401') != -1){
                this.dialogError = true;
                this.returnedErrorMessage = 'Sessão expirada.';
                this.$router.push({ name: 'login' });
            }
        });
        },
        async searchStreeByCEP(){
            if (this.enderecoSolicitacao.cep != null) {
                this.setEmptyAddress();
                let cepBusca =this.enderecoSolicitacao.cep;
                this.loading = true;
                try {
                    await this.$store.dispatch("lists/getStreetByCEP",cepBusca);
                    let borough = this.$store.state.lists.getStreetByCEP;
                    if(borough != null && borough.Status == "OK"){
                        if(borough.NomeTipoLogradouro != null){
                            let streetType = this.filterTypeStreet(this.listTipoLogradouro, borough.NomeTipoLogradouro);

                            if(streetType != null){
                                this.enderecoSolicitacao.codigoTipoLogradouro = streetType.ci_tipo_logradouro;
                            }
                        }

                        if(borough.NomeLogradouro != null)
                            this.enderecoSolicitacao.nomeLogradouro = borough.NomeLogradouro;
                        if(borough.NomeBairro != null)
                            this.enderecoSolicitacao.nomeBairro = borough.NomeBairro;
                        if(borough.SiglaUF != this.enderecoSolicitacao.siglaUF){
                            this.enderecoSolicitacao.siglaUF = borough.SiglaUF;
                            this.loadCities(borough.SiglaUF, 'address')
                            .then(success => {
                                if(success != null)
                                    console.log(success);
                                if(borough.CodigoCidade != null){
                                    this.enderecoSolicitacao.codigoCidade = borough.CodigoCidade;
                                }
                            })
                        }
                        if(borough.CodigoSubprefeitura != null){
                            this.enderecoSolicitacao.codigoSubprefeitura = borough.CodigoSubprefeitura;
                            this.changeBorough(borough.CodigoSubprefeitura)
                            .then(success =>{
                                if(success != null)
                                    console.log(success);
                                this.enderecoSolicitacao.codigoDistrito = borough.NumeroDistrito;
                            });
                        }
                    } else if(borough.Status == "NOK"){
                        this.dialogError = true;
                        this.returnedTitleMessage= "Busca de CEP";
                        this.returnedErrorMessage = borough.Mensagem;
                        return false;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false;
                }
            } else {
                this.setEmptyAddress(true);
            }
        },
        cepChange(value){
            if(value == null){
                this.setEmptyAddress(false);        
            }
        },
        setEmptyAddress(cleanCEP = false){
            this.listDistrict = [];
            if(this.enderecoSolicitacao == null) {
                this.enderecoSolicitacao = {
                    codigoTipoLogradouro: '',
                    codigoSubprefeitura: '',
                    codigoDistrito: '',
                    pontoReferencia: '',
                    nomeLogradouro: '',
                    numeroLogradouro: '',
                    complemento: '',
                    nomeBairro: '',
                    cep: '',
                    codigoCidade: '',
                    siglaUF: ''
                };
            } else {
                this.enderecoSolicitacao.codigoTipoLogradouro = '';
                this.enderecoSolicitacao.codigoSubprefeitura = '';
                this.enderecoSolicitacao.codigoDistrito = '';
                this.enderecoSolicitacao.pontoReferencia = '';
                this.enderecoSolicitacao.nomeLogradouro = '';
                this.enderecoSolicitacao.numeroLogradouro = '';
                this.enderecoSolicitacao.complemento = '';
                this.enderecoSolicitacao.nomeBairro = '';
                if(cleanCEP)
                    this.enderecoSolicitacao.cep = '';
                this.enderecoSolicitacao.codigoCidade = '';
                this.enderecoSolicitacao.siglaUF = '';
            }
        },
        filterTypeStreet(listaTipoLogradouro, tipoLogradouro){
        let arrTipoLogradouro = listaTipoLogradouro.filter((tl) => { return tl.tipo_logradouro.trim().toLowerCase() == tipoLogradouro.trim().toLowerCase() });
        return (arrTipoLogradouro != null && arrTipoLogradouro.length > 0) ? arrTipoLogradouro[0] : null;
        },
        async loadBorough(){
        await this.$store.dispatch("lists/listSubPrefeituras");
        },
        async loadCities(item, type){
        if(item != null)
        {
            await this.$store.dispatch("lists/listCidadesPorUf", item.toString());
            try{
                let result = this.$store.state.lists.list;
                if(result != null){
                    if(type == "address")
                        this.listCityAddress = result;
                }
            }catch (error){
                this.showSnackbar(error, 'error');
                console.log(error);
            }
        }
        },
        async loadStreetType(){
        await this.$store.dispatch("lists/listTipoLogradouro");
        }, 
        async changeBorough(item) {
            if (item != null) {
                await this.$store.dispatch("lists/listDistritos",item.toString());
                try {
                    let districts = this.$store.state.lists.list;
                    this.listDistrict = districts;
                } catch (error) {
                    this.showSnackbar(error, 'error');
                }
            } else {
                this.listDistrict = [];
            }
        },
        async loadServiceType(idOrigemProcura){
            await this.$store.dispatch("lists/listTipologiaServicoReordenamento", idOrigemProcura);
        },
        async loadServiceTypeReception(idOrigemProcura){
            await this.$store.dispatch("lists/listTipologiaServicoAcolhimento", idOrigemProcura);
        },
        async listServiceByRequestType(typeRequest){

            console.log("typeRequest01", typeRequest);

            let cdOrigemProcura = this.getOrigemProcura();
            this.tipoServicoReordenamentoAcolhimento = '';
            this.motivoReordenamento = '';
            this.motivoProcura = '';

            console.log("typeRequest", typeRequest);

            if(typeRequest == "R"){
                this.tipoSolicitacao = 'R';
                this.$store.dispatch("lists/listTipologiaServicoReordenamento", this.getOrigemProcura())
                        .then(() => {
                            this.labelTipoServico = 'Tipo de serviço para reordenamento';
                            this.listTipologiaPorTipoSolicitacao = this.listTipologiaServicoReordenamento;
                        });    

            } else {
               
                    if(cdOrigemProcura == null || cdOrigemProcura == undefined || cdOrigemProcura == "")
                    {
                        this.tipoSolicitacao = 'R';
                        this.labelTipoServico = 'Tipo de serviço para reordenamento';
                        this.showSnackbar('Não foi possível identificar o órgão solicitante.', 'error');
                    } else {
                        this.tipoSolicitacao = 'A';
                        this.$store.dispatch("lists/listTipologiaServicoAcolhimento", this.getOrigemProcura())
                        .then(() => {
                            this.listTipologiaPorTipoSolicitacao = this.listTipologiaServicoAcolhimento;
                            this.labelTipoServico = 'Tipo de serviço para acolhimento';
                        });
                    
                }
            }
        },
        checkProfileRequest(){
            let countCitizen = (this.listCitizen != null) ? this.listCitizen.length : 0;
            if(countCitizen == 1)
                this.tipoPerfilSolicitacao = 'I';
            else if(countCitizen > 1)
                this.tipoPerfilSolicitacao = 'G';
            else
                this.tipoSolicitacao = '';                    
        },
        isTrueValue(value){
            let isTrue = ((value != undefined) && (value == "true" || value == "1" || value == true || value === 1));
            return isTrue;
        },
        checkOrigemProcuraRequired(value){
            return !(this.isTrueValue(this.isDelegatedUser) && !(value != null && value.toString().length > 0));
        },
        checkOrgaoSolicitanteRequired(value){

            if (this.isTrueValue(this.isDelegatedUser))
            {
               return (
                    (this.codigoOrigemProcura != null && this.codigoOrigemProcura.toString().length > 0)
                    && (this.listOrgaos != null && this.listOrgaos.length > 0)
                    && value != null && value.toString().length > 0);    
            }
            else {
            return !(this.isTrueValue(this.isDelegatedUser) 
                    && (this.codigoOrigemProcura != null && this.codigoOrigemProcura.toString().length > 0)
                    && (this.listOrgaos != null && this.listOrgaos.length > 0)
                    && (value != null && value.length > 0));
                }        
        },
        validaMotivoReordenamentoObrigatorio(valor){
            if(this.tipoSolicitacao == 'R'){
                if(valor == null || valor == undefined || valor < 1){
                    return false;
                }
            }
            return true;
        },
        validaMotivoAcolhimentoObrigatorio(valor){
            if(this.tipoSolicitacao == 'A'){
                if(valor == null || valor == undefined || valor < 1){
                    return false;
                }
            }
            return true;
        },
        getPresentAge(value){
            let presentDay = moment();
            let birthDate = moment(value);
            let valid = birthDate.isValid();
            if(valid){
                return presentDay.diff(birthDate, 'years');
            }
            else {
                return 0;
            }            
            //this.checkIfPregnantFieldEnabled();
        }


    },
}

function ValidarNumeroDefault (value) {
      
      let result = "";
     // let count = 0;
      if (value) {
        
        let arrayValue = value.toString().split("");

        for (var x = 0; x < arrayValue.length; x++) {
          if (arrayValue[x] != "(" && arrayValue[x] != ")" && arrayValue[x] != "-" && arrayValue[x] != " ") {
            if(!Number.isInteger(parseInt(arrayValue[x])))
            {
                   return false; 
            }
            result = result + arrayValue[x];
          }
        }
        return true;
    }
}
</script>
<style scoped>
    .modalFile {
       overflow-y: hidden;        
    }
</style>
